import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/core/api.service';
import { SyncCryptService } from 'src/app/core/crypt/sync-crypt.service';
import { UserService } from 'src/app/core/user.service';
import { FileItemService } from 'src/app/file/file-item.service';
import { User } from 'src/app/shared/models';
import { FileItem } from 'src/app/shared/models/files.model';
@Injectable({
    providedIn: 'root',
})
export class ActivityLogItemService {
    public user: User;
    constructor(
        private apiService: ApiService,
        private syncCryptService: SyncCryptService,
        private fileItemService: FileItemService,
        private userService: UserService,
        private router: Router,
    ) {}

    public getEvent(eventId: string) {
        return this.apiService.execute('eventslist', { _id: eventId });
    }

    public format(event: any) {
        if (!event.items) {
            return event;
        }

        if (event.eventtype.indexOf('path-') > -1 && event.items.pathitems) {
            return this.formatPath(event);
        } else if (
            event.eventtype.indexOf('link-') > -1 &&
            event.items.enc_meta_name
        ) {
            return this.formatLink(event);
        } else if (
            event.eventtype.indexOf('share-') > -1 &&
            (event.items.meta_name || event.items.enc_meta_name)
        ) {
            return this.formatLink(event);
        } else {
            return event;
        }
    }
    public async processPathitem(path: any) {
        const encMetaName = path.enc_meta_name || path.meta_name;
        const fileSize = path.size;
        return await new Promise<void>(async (resolve, reject) => {
            if (!encMetaName) {
                resolve(path);
            } else {
                try {
                    const fname = await this.syncCryptService.filenameDecrypt(
                        encMetaName
                    );
                    path.name = fname;
                    path.file_size = this.fileItemService.bytesToSize(fileSize);
                    resolve(path);
                } catch (error) {
                    path.name = encMetaName;
                    resolve(path);
                }
            }
        });
    }

    private async formatLink(event: any) {
        const evtItem = await this.processPathitem(event.items);
        event.items = evtItem;
        return event;
    }

    private async formatPath(event: any) {
        const pathitemPromise: Promise<any>[] = [];
        for (let i = 0, len = event.items.pathitems.length; i < len; i++) {
            pathitemPromise.push(
                this.processPathitem(event.items.pathitems[i])
            );
        }
        const result = await Promise.all(pathitemPromise);
        event.items.pathitems = result;
        if (event.items.enc_meta_name) {
            const items = await this.processPathitem(event.items);
            event.items = items;
            return event;
        } else {
            return event;
        }
    }

    public isFile(synctype: string[]): boolean {
        return synctype.indexOf('stDIR') == -1;
    }

    public getStateParams(file: any) {
      let item: FileItem;
      item = file;
      const isDeleted = file.active <= 0;
        if (isDeleted) {
          return { showDeleted: 1, highlight: item.sync_id };
        } else {
          return {}
        }
    }

    public itemLink(file: any) {
        let item: FileItem;
        item = file;
        this.user = this.userService.getUser();
        let type = 'default';
        const isDeleted = file.active <= 0;

        if (isDeleted) {
          if (item.invault === 1) {
            return `/vault/${item.sync_pid}`;
          } else {
            return `/files/${item.sync_pid}`;
          }
        }

        if (!this.isFile(file.synctype)) {
          if (item.invault === 1) {
            return `/vault/${item.sync_id}`;
          } else {
            return `/files/${item.sync_id}`;
          }
        } else if (this.fileItemService.isImage(item)) {
          type = 'image';
        // We don't get mimetype in event details pathitem so this type 'text' check is not checked here
        // } else if (this.fileItemService.isText(item)) {
        //   type = 'text';
        } else if (
          this.fileItemService.isPDF(item) &&
          (item.context == 'link' || item.context == 'applink') &&
          item.previewonly
        ) {
          type = 'doc';
        } else if (
          this.fileItemService.isPDF(item) &&
          item.context == 'files'
        ) {
          type = 'doc';
        } else if (this.display_office(item)) {
          type = 'office';
        } else if (this.display_doc(item)) {
          type = 'doc';
        } else {
          type = 'default';
        }
        return `/file/${item.sync_id}/view/${type}`;
      }
    
      private display_office(item: FileItem) {
        return (
          this.fileItemService.isMSOffice(item, 'embedview') &&
          // Only enabled in files, for now
          item.context === 'files' &&
          this.user.is_office === 1
        );
      }
    
      private display_doc(item: FileItem) {
        return (
          this.fileItemService.isDocument(item) &&
          // only compat links
          ((item.compat &&
            (item.context == 'link' || item.context == 'applink')) ||
            item.context == 'files')
        );
      }
}
